import { objectSchemaOf, Joi } from '../helpers';
import type { IEntityType } from './entityType';
import { entityTypeSchema } from './entityType';

export interface IEvaluateParams {
  text: string;
  context?: string[];
  conversationId?: string;
  entityTypes?: IEntityType[];
}

export const evaluateParamsSchema = objectSchemaOf<IEvaluateParams>({
  text: Joi.string().required(),
  context: Joi.array().items(Joi.string()).optional(),
  conversationId: Joi.string().optional(),
  entityTypes: Joi.array().items(entityTypeSchema).optional(),
});

export interface IEvaluateResult {
  confidence: string;
  intent: string;
  context?: string[];
  slots?: Record<string, string>;
}
